export default __webpack_public_path__ + "static/media/MBChurchillOpen.2e84c0d6.jpg";